import api from './api.service';
import { UserResponse, CreateUserRequest, UpdateUserRequest } from '../types/user';

class UsersService {
  async getUsers(): Promise<UserResponse[]> {
    const response = await api.get('/users');
    return response.data;
  }

  async createUser(data: CreateUserRequest): Promise<UserResponse> {
    const response = await api.post('/users', data);
    return response.data;
  }

  async updateUser(userId: string, data: UpdateUserRequest): Promise<UserResponse> {
    const response = await api.put(`/users/${userId}`, data);
    return response.data;
  }

  async deleteUser(userId: string): Promise<void> {
    await api.delete(`/users/${userId}`);
  }
}

export const usersService = new UsersService();
